import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { setTitleHeader } from '@global/helpers';
import PdfViewerScreen from '@/screens/pdf/PdfViewerScreen';

const Stack = createStackNavigator();

const PdfNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="PdfScreen"
      screenOptions={(props) => ({
        headerShown: false,
      })}>
      <Stack.Screen
        name="PdfScreen"
        component={PdfViewerScreen}
        options={{
          title: setTitleHeader('PDF Viewer'),
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  );
};

export default PdfNavigator;
